import { memo, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// UI
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";

import { OfferSaleEditCardProps } from "./types";
import { useHandleTextFieldChange, useHandleNumberFieldChange } from "services/forms/hooks";
import { Errors } from "services/forms/validation/types";
import { OFFER_SALE_EDIT_FORM_SCHEMA } from "./validation";
import { validateYup } from "services/forms/validation/validation";
import { useDispatch } from "react-redux";
import { updateSettings } from "services/api/settings/redux";
import { TextArea } from "ui/components/TextField/TextArea";



const OfferSaleEditCard: React.FC<OfferSaleEditCardProps> = (props) => {
    const { setting, setSetting, onSuccess, onClose } = props;

    const { t } = useTranslate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [errors, setErrors] = useState<Errors>({});


    const handleFormSubmit = async (e: any) => {
        e.preventDefault();

        const isValid = validateYup(
            setting,
            OFFER_SALE_EDIT_FORM_SCHEMA,
            setErrors
        );

        if (!isValid) {
            return;
        }

        setIsLoading(true);

        try {
            if (setting.id) {
                await dispatch(updateSettings(setting) as any)
                if (onSuccess) onSuccess();
            }

        } catch (e) {
            setIsLoading(false);
            return;
        }

        setIsLoading(false);
    };

    const handleTextFieldChange = useHandleTextFieldChange(
        setSetting,
        setting
    );

    const handleNumberFieldChange = useHandleNumberFieldChange(
        setSetting,
        setting
    );

    return (
        <>
            <div className="flex gap-4">
                <div className="w-full m-auto">
                    <div className="flex gap-3 h-full">
                        <form noValidate className="text-left flex-1 " onSubmit={handleFormSubmit}>
                            <div className="p-4">
                                <div className="mb-3">
                                    <TextField
                                        type="text"
                                        name="offerSaleFormatNumber"
                                        label={t("admin.setting.document.offer.sale.edit.offernumber")}
                                        placeholder={t("admin.setting.document.offer.sale.edit.offernumber")}
                                        onChange={handleTextFieldChange}
                                        value={setting.offerSaleFormatNumber}
                                        error={errors.offerSaleFormatNumber}
                                        required

                                    ></TextField>
                                </div>

                                <div className="mb-3">
                                    <ul className="common-list text-sm">
                                        <li>{t("{YYYY} - godina kreiranja ponude")}</li>
                                        <li>{t("{YY} - zadnje dvije znamenke godine kreiranja ponude")}</li>
                                        <li>{t("{MM} - mjesec kreiranja ponude")}</li>
                                        <li>{t("{DD} - dan kreiranja ponude")}</li>
                                        <li>{t("{ID} - Identifikator ponude u toj godini")}</li>
                                    </ul>
                                </div>
                                <div className="mb-3">
                                    <NumberField
                                        name="offerSaleDurationDays"
                                        label={t("admin.setting.document.offer.sale.edit.durationdays")}
                                        onChange={handleNumberFieldChange}
                                        value={setting.offerSaleDurationDays}
                                        decimals={0}
                                    />
                                </div>
                                <div className="mb-3">
                                    <TextArea
                                        name="offerSaleNoteDefault"
                                        label={t("admin.setting.document.offer.sale.edit.notedefault")}
                                        placeholder={t("admin.setting.document.offer.sale.edit.placeholder")}
                                        value={setting.offerSaleNoteDefault}
                                        onChange={handleTextFieldChange}
                                    ></TextArea>
                                </div>
                            </div>
                            <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
                                <Button
                                    variant="outlined"
                                    children={t("admin.close")}
                                    onClick={() => onClose()}
                                />
                                <Button
                                    variant="primary"
                                    children={t("admin.save")}
                                    type="submit"
                                />
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </>
    );
};
export default memo(OfferSaleEditCard);
